import React from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper';
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import {
    Button,
    Card,
    Form,
    notification,
    Tabs,
} from 'antd'

import { hideLoader, showLoader } from '../../../modules/actions'
import _ from 'lodash'
import Request from '../../../request'
import { connect } from 'react-redux'

const TabPane = Tabs.TabPane;
let autoFollowUpID = '';

@Form.create()
class AddAutoFollowUp extends React.Component {
    state = {
        loading: false,
        day: '',
        emailTemplateId: '',
        smsTemplateId: '',
        whatsAppTemplateId: '',
        fireOn: { "visaDesk": [{ id: 'visaDesk.fileStatus', display: 'File Status' }, { id: 'visaDesk.visaStatus', display: 'Visa Status' }] },
        testTriggers: {
            "visaDesk.fileStatus": [{ id: 'COE/Receipt Received', display: 'COE/Receipt Received' }, { id: 'Financial Documents Pending', display: 'Financial Documents Pending' }, { id: 'Final Visa File Review', display: 'Final Visa File Review' }, { id: 'GIC Waiting', display: 'GIC Waiting' }],
            "visaDesk.visaStatus": [{ id: 'Visa Waiting', display: 'Visa Waiting' }, { id: 'visaDesk.visaApprovalDate', display: 'Visa Approved' }, { id: 'Visa Denied', display: 'Visa Denied' }]
        },
        triggers: {
            "counsellingDesk": [{ id: 'Counsellor Assign', display: 'Counsellor Assign' }, { id: 'Courses Shortlisted', display: 'Courses Shortlisted' }, { id: 'More Course Options Required', display: 'More Course Options Required' }],
            "registrationsDesk": [{ id: 'Consultancy Fee (Country Wise)', display: 'Consultancy Fee (Country Wise)' }, { id: 'Consultancy Fee Paid', display: 'Consultancy Fee Paid' }],
            "applicationsDesk": [{ id: 'Admission Assign', display: 'Admission Assign' }, { id: 'Submit Docs & Apply Soon', display: 'Submit Docs & Apply Soon' }, { id: 'Application To Be Processed', display: 'Application To Be Processed' }, { id: 'Additional Documents Required', display: 'Additional Documents Required' },
            { id: 'Offer Letter Received', display: 'Offer Letter Received' }, { id: 'Offer Denied', display: 'Offer Denied' }, { id: 'Interview Required', display: 'Interview Required' }],
            "visaDesk": [{ id: 'Visa Team Assigned', display: 'Visa Team Assigned' }, { id: 'Book Your Medical Exam', display: 'Book Your Medical Exam' }, { id: 'College Fee Pending', display: 'College Fee Pending' }, { id: 'Fee Receipt Received', display: 'Fee Receipt Received' }, { id: 'Consultancy Fee Pending', display: 'Consultancy Fee Pending' },
            { id: 'Required Documents For Visa Application', display: 'Required Documents For Visa Application' }, { id: 'Open Your GIC Account', display: 'Open Your GIC Account' }, { id: 'Visa Application Filed', display: 'Visa Application Filed' }, { id: 'visaDesk.visaApprovalDate', display: 'Visa Approved' }, { id: 'Visa Denied', display: 'Visa Denied' }]
        },
        inputTypes: {
            fields: [
                {
                    label: 'Day',
                    key: 'day',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Day',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            day: val
                        })
                    }
                },
                {
                    label: 'Hour',
                    key: 'hour',
                    required: true,
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Hour Duration',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            hour: val
                        })
                    }
                },
                {
                    label: 'Email Template',
                    key: 'emailTemplateId',
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Template',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            emailTemplateId: val
                        })
                    }
                },
                {
                    label: 'Desk',
                    key: 'desk',
                    required: true,
                    type: 'select',
                    options: [{ id: 'counsellingDesk', display: 'Counselling Desk' }, { id: 'registrationsDesk', display: 'Registration Desk' },
                    { id: 'applicationsDesk', display: 'Application Desk' }, { id: 'visaDesk', display: 'Visa Desk' }],
                    onChange: v => {
                        this.props.form.setFieldsValue({ desk: v })
                        this.updateFireOn(v)
                    }
                },
                {
                    label: 'Fire On',
                    key: 'fireOn',
                    required: true,
                    type: 'select',
                    options: [],
                    onChange: v => {
                        this.props.form.setFieldsValue({ fireOn: v })
                        this.updateTriggers(v)
                    }
                },
                {
                    label: 'Fire After',
                    key: 'trigger',
                    type: 'select',
                    showSearch: true,
                    options: [],
                    onChange: v => {
                        this.props.form.setFieldsValue({ trigger: v })
                    }
                },
                {
                    label: 'SMS Template',
                    key: 'smsTemplateId',
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Template',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            smsTemplateId: val
                        })
                    }
                },
                {
                    label: 'Whats App Template',
                    key: 'whatsAppTemplateId',
                    showSearch: true,
                    allowClear: true,
                    placeholder: 'Select Template',
                    type: 'select',
                    disabled: false,
                    options: [],
                    onChange: val => {
                        this.props.form.setFieldsValue({
                            whatsAppTemplateId: val
                        })
                    }
                }
            ]
        }
    }

    constructor(props) {
        super(props)
        this.loadTemplates();
    }

    updateFireOn = (data) => {
        let inputTypes = this.state.inputTypes
        let trigger = this.state.fireOn[data]
        inputTypes['fields'][4].options = trigger && trigger.length ? trigger : [];
        this.setState({ inputTypes })
    }

    updateTriggers = (data) => {
        let inputTypes = this.state.inputTypes
        let trigger = this.state.testTriggers[data]
        inputTypes['fields'][5].options = trigger
        this.setState({ inputTypes })
    }


    loadTemplates = async () => {
        let emailTemplatesData = await Request.getTemplatesForCommunication('Email')
        let emailTemplatesDataArray = emailTemplatesData.reduce((temp, vv) => {
            vv.display = vv.templateName
            vv.id = vv._id
            temp.push(vv)
            return temp
        }, [])
        let smsTemplatesData = await Request.getTemplatesForCommunication('SMS')
        let smsTemplatesDataArray = smsTemplatesData.reduce((temp, vv) => {
            vv.display = vv.templateName
            vv.id = vv._id
            temp.push(vv)
            return temp
        }, [])
        let whatsAppTemplatesData = await Request.getTemplatesForCommunication('Whatsapp')
        let whatsAppTemplatesDataArray = whatsAppTemplatesData.reduce((temp, vv) => {
            vv.display = vv.templateName
            vv.id = vv._id
            temp.push(vv)
            return temp
        }, [])

        let inputTypes = this.state.inputTypes
        let dayArray = [];
        let hourArray = [];
        for (var hourIndex = 1; hourIndex < 24; hourIndex++) {
            hourArray.push(hourIndex)
        }
        for (var dayIndex = 1; dayIndex < 31; dayIndex++) {
            dayArray.push(dayIndex);
        }
        inputTypes['fields'][0].options = dayArray;
        inputTypes['fields'][1].options = hourArray;
        inputTypes['fields'][2].options = emailTemplatesDataArray;
        inputTypes['fields'][6].options = smsTemplatesDataArray;
        inputTypes['fields'][7].options = whatsAppTemplatesDataArray;

        this.setState({ inputTypes: inputTypes })
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props;
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                if (autoFollowUpID) {
                    values = { ...values, _id: autoFollowUpID }

                    dispatch(showLoader())
                    let x = await Request.updateAutoFollowUp(values)
                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                } else {
                    dispatch(showLoader())
                    let x = await Request.addAutoFollowUp(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()

                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }

    setFormValues = async autoFollowUpID => {

        try {
            let { doc } = await Request.getAutoFollowUp(autoFollowUpID)
            if (doc) {
                let tempObj = {}

                let inputTypes = this.state.inputTypes

                _.each(inputTypes.fields, (v, k) => {
                    tempObj[v.key] = doc[v.key]
                })

                this.props.form.setFieldsValue(tempObj)
            }
        } catch (e) {
            console.log(e)
        }
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        autoFollowUpID = searchParams.get('id')
        if (autoFollowUpID) {
            this.setFormValues(autoFollowUpID)
        }

        setTimeout(() => {
        }, 2000)
    }

    render() {
        const {
            form: { getFieldDecorator }
        } = this.props;

        const { inputTypes } = this.state;

        return (
            <PageHeaderWrapper title={autoFollowUpID ? 'Edit Auto Follow Up' : 'Add Auto Follow Up'}>
                <Card bordered={true}>
                    <Tabs onChange={this.callback} type="card">
                        <TabPane tab={'General Info'} key={0}>
                            <div style={{ padding: 20 }}>

                                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>

                                    <GetAllFormFields
                                        inputSchema={inputTypes}
                                        loading={this.props.loading}
                                        getFieldDecorator={getFieldDecorator}
                                    />
                                    <div style={{ textAlign: 'center' }}>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={this.props.loading}>
                                            SAVE
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAutoFollowUp)
